import React from 'react'
import { Card, Space, Button, Typography, Tag, theme } from 'antd'
import { BellOutlined, CheckOutlined, EditOutlined, UserOutlined } from '@ant-design/icons'
import { getPriorityTag, getFriendlyDateDisplay, getCategoryTag, getDepartmentTag } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const { Text, Paragraph } = Typography

const ReminderCard = ({ reminder, onAcknowledge, onEdit }) => {
  const { token } = theme.useToken()

  return (
    <Card
      size='small'
      style={{ marginBottom: '16px' }}
      title={
        <Space>
          <BellOutlined style={{ fontSize: '18px' }} />
          <Text strong>{reminder.reminderTitle}</Text>
          {getPriorityTag(reminder.priority)}
        </Space>
      }
      extra={
        <Space>
          {!reminder.isAcknowledged && (
            <Button
              size='small'
              icon={<CheckOutlined style={{ color: token.colorSuccess }} />}
              onClick={() => onAcknowledge(reminder)}
              style={{
                background: hexToRGBA(token.colorSuccess, 0.1),
                borderColor: token.colorSuccess,
                color: token.colorSuccess
              }}
            >
              Acknowledge
            </Button>
          )}
          <Button
            size='small'
            icon={<EditOutlined style={{ color: token.colorPrimary }} />}
            onClick={() => onEdit(reminder)}
            style={{
              background: hexToRGBA(token.colorPrimary, 0.1),
              borderColor: token.colorPrimary
            }}
          />
        </Space>
      }
    >
      <Paragraph>{reminder.reminderDetails}</Paragraph>
      <Space style={{ marginTop: '8px' }}>
        <UserOutlined />
        <Text>For: {reminder.staffName}</Text>
      </Space>
      <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'space-between' }}>
        <Space>
          {getCategoryTag(reminder.category)}
          {getDepartmentTag(reminder.department)}
        </Space>
        <Text type='secondary'>{getFriendlyDateDisplay(reminder.reminderDate)}</Text>
      </div>
    </Card>
  )
}

export default ReminderCard
